import React from 'react'

const OutsideLabel: React.FC<React.PropsWithChildren<object>> = ({ children }) => (
	<label className="text-base">{children}</label>
)

export default OutsideLabel
